<mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>
<!-- <div [hidden]="showSpinner"> -->
  <div class="child" *ngIf="hideInput;else voteingTable">
    <mat-card class="example-card">
      <mat-card-header class="cd-header" [ngClass]="type=='success' ? 'cd-header-s':'cd-header-f'">
        <mat-card-title>{{errorType}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p style="padding-top: 2vh;">
          {{errorMessage}}
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  
  <ng-template #voteingTable >
    <div style="margin-left: 3vw;" [hidden]="showSpinner">
      <br/>
      <h2>{{pollMessage}}</h2><br/>
      <table>
        <tr>
          <th *ngFor="let data of optionNameList;">{{data}}</th>
        </tr>
        <tr *ngFor="let data of tableData, let rowIndex = index">
          <td>{{data.opt}}</td>
          <td *ngFor="let data1 of data.value; let colIndex = index">
            <input type="checkbox" [(ngModel)]="data1.val" (change)='handleClick(rowIndex,colIndex,$event);' [disabled]="data1.disable" class="ch-box">
        </tr>
      </table>
      <div>
        <div style="margin-left: 33%; margin-top: 2vh;">
          <button (click)= "resetValues()" mat-raised-button style="margin-right: 2vh;">Reset</button>
          <button (click)= "onSubmit()" mat-raised-button >Submit</button>
        </div>
      </div>
    </div>
  </ng-template>
<!-- </div> -->


